import {
  ApartmentOutlined,
  AnalyticsOutlined,
  InfoOutlined,
  ChevronRightRounded,
  Close,
  Logout,
  Menu,
  MenuBookOutlined,
  Newspaper,
  PhotoLibraryOutlined,
  People,
  PeopleOutlineOutlined,
  Reviews,
  Redeem,
  Groups2Outlined,
  EventNoteOutlined,
} from "@mui/icons-material";
import {
  Box,
  Button,
  Grid,
  IconButton,
  Typography,
  Drawer,
} from "@mui/material";
import React from "react";
import { isMobile } from "react-device-detect";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "reactfire";
import { styled, useTheme } from "@mui/material/styles";
import theme from "../../providers/theme";
import { MAIN_THEME_COLOR } from "../../providers/theme/colors/colors";
import useUser from "../../providers/user_provider/user_provider";
import useAdminAccess from "../../hooks/use_admin_access";
import { canAccessModule } from "../../utils/admin_access";

const drawerWidth = 240;

const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })<{
  open?: boolean;
}>(({ theme, open }) => ({
  flexGrow: 1,
  padding: theme.spacing(3),
  transition: theme.transitions.create("margin", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  marginRight: -drawerWidth,
  ...(open && {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginRight: 0,
  }),

  position: "relative",
}));

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  justifyContent: "flex-start",
}));

function MobileDrawer(props: {}) {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { } = props;
  const auth = useAuth();
  const { setMobileDrawerOpen, mobileDrawerOpen } = useUser();
  const { allowedModules } = useAdminAccess();

  let dashboardItems = [
    {
      id: 1,
      name: "Dashboard",
      path: "/admin/home",
      module: "dashboard",
      activeIcon: <AnalyticsOutlined sx={{ pl: 1, color: "#0085DB" }} />,
      inActiveicon: <AnalyticsOutlined sx={{ pl: 1, color: "#565564" }} />,
    },
    {
      id: 2,
      name: "About Us",
      path: "/admin/about",
      module: "about",
      activeIcon: <InfoOutlined sx={{ pl: 1, color: "#0085DB" }} />,
      inActiveicon: <InfoOutlined sx={{ pl: 1, color: "#565564" }} />,
    },
    {
      id: 3,
      name: "DEXCO",
      path: "/admin/dexco",
      module: "about",
      activeIcon: <Groups2Outlined sx={{ pl: 1, color: "#0085DB" }} />,
      inActiveicon: <Groups2Outlined sx={{ pl: 1, color: "#565564" }} />,
    },
    {
      id: 4,
      name: "Users",
      path: "/admin/users",
      module: "users",
      activeIcon: <People sx={{ pl: 1, color: "#0085DB" }} />,
      inActiveicon: <PeopleOutlineOutlined sx={{ pl: 1, color: "#565564" }} />,
    },
    {
      id: 5,
      name: "News",
      path: "/admin/news",
      module: "news",
      activeIcon: <Newspaper sx={{ pl: 1, color: "#0085DB" }} />,
      inActiveicon: <Newspaper sx={{ pl: 1, color: "#565564" }} />,
    },
    {
      id: 6,
      name: "Gallery",
      path: "/admin/gallery",
      module: "gallery",
      activeIcon: <PhotoLibraryOutlined sx={{ pl: 1, color: "#0085DB" }} />,
      inActiveicon: <PhotoLibraryOutlined sx={{ pl: 1, color: "#565564" }} />,
    },
    {
      id: 7,
      name: "Yuvagaaz",
      path: "/admin/yuvagaaz",
      module: "yuvagaaz",
      activeIcon: <MenuBookOutlined sx={{ pl: 1, color: "#0085DB" }} />,
      inActiveicon: <MenuBookOutlined sx={{ pl: 1, color: "#565564" }} />,
    },
    {
      id: 8,
      name: "Deanery",
      path: "/admin/deanery-members",
      module: "deanery",
      activeIcon: <ApartmentOutlined sx={{ pl: 1, color: "#0085DB" }} />,
      inActiveicon: <ApartmentOutlined sx={{ pl: 1, color: "#565564" }} />,
    },
    {
      id: 9,
      name: "Survey",
      path: "/admin/surveys",
      module: "surveys",
      activeIcon: <Reviews sx={{ pl: 1, color: "#ffffff" }} />,
      inActiveicon: <Reviews sx={{ pl: 1, color: "#565564" }} />,
    },
    {
      id: 10,
      name: "REDON",
      path: "/admin/redon",
      module: "redon",
      activeIcon: <Redeem sx={{ pl: 1, color: "#0085DB" }} />,
      inActiveicon: <Redeem sx={{ pl: 1, color: "#565564" }} />,
    },
    {
      id: 11,
      name: "YouCat",
      path: "/admin/youcat",
      module: "youcat",
      activeIcon: <MenuBookOutlined sx={{ pl: 1, color: "#0085DB" }} />,
      inActiveicon: <MenuBookOutlined sx={{ pl: 1, color: "#565564" }} />,
    },
    {
      id: 12,
      name: "DYC",
      path: "/admin/dyc",
      module: "dyc",
      activeIcon: <EventNoteOutlined sx={{ pl: 1, color: "#0085DB" }} />,
      inActiveicon: <EventNoteOutlined sx={{ pl: 1, color: "#565564" }} />,
    },
    {
      id: 13,
      name: "Logout",
      path: "",
      activeIcon: <Logout sx={{ pl: 1, color: "#ffffff" }} />,
      inActiveicon: <Logout sx={{ pl: 1, color: "#565564" }} />,
    },
  ];

  const handleDrawerClose = () => {
    setMobileDrawerOpen(false);
  };

  return (
    <Box display={"flex"} flexDirection={"column"}>
      <Main open={mobileDrawerOpen}>
        <Drawer
          sx={{
            width: drawerWidth,
            flexShrink: 0,
            "& .MuiDrawer-paper": {
              width: drawerWidth,
            },
          }}
          variant="persistent"
          anchor="left"
          open={mobileDrawerOpen}
        >
          <DrawerHeader>
            <IconButton onClick={handleDrawerClose}>
              {theme.direction === "rtl" ? <Close /> : <Close />}
            </IconButton>
          </DrawerHeader>
          <Box display={"flex"} flexDirection={"column"}>
            {dashboardItems
              .filter((item) => item.name === "Logout" || canAccessModule(allowedModules, item.module as any))
              .map((item, index) => (
              <Box
                key={item.id}
                display={"flex"}
                flexDirection={"row"}
                alignItems={"center"}
                justifyContent={"space-between"}
                m={2}
              >
                <Box sx={{ borderBottom: `1px solid ${MAIN_THEME_COLOR}` }}>
                  {item.name === "Logout" ? (
                    <Typography
                      color={"#1B001B"}
                      onClick={() => {
                        auth?.signOut();
                        setMobileDrawerOpen(false);
                        navigate("/admin/login");
                      }}
                    >
                      {item?.name}
                    </Typography>
                  ) : (
                    <Link
                      to={item?.path}
                      style={{
                        textDecoration: "none",
                        width: "fit-content",
                      }}
                      onClick={() => {
                        setMobileDrawerOpen(false);
                        window.scrollTo(0, 0);
                      }}
                    >
                      <Typography color={"#1B001B"}>{item?.name}</Typography>
                    </Link>
                  )}
                </Box>
                <ChevronRightRounded
                  onClick={() => {
                    if (item.name === "Logout") {
                      auth?.signOut();
                      setMobileDrawerOpen(false);
                      navigate("/admin/login");
                    } else {
                      navigate(item?.path);
                    }
                  }}
                />
              </Box>
            ))}
          </Box>
        </Drawer>
      </Main>
    </Box>
  );
}

export default MobileDrawer;
